import React from "react";

// reactstrap components
import { Container, Row, Col, Button } from "reactstrap";

const Team = () => {
  return (
    <div className="section section-team text-center">
      <Container>
        <h2 className="title">Here is our team</h2>
        <div className="team">
          <Row>
            <Col>
              <div className="team-player">
                <img
                  alt="..."
                  className="rounded-circle img-fluid img-raised"
                  src={
                    require("../../assets/img/35225371_10156435174191369_3919318894967259136_n.jpg")
                      .default
                  }
                ></img>
                <h4 className="title">Elton Davids</h4>
                <p className="category text-info">Director</p>
                <p className="description">
                  His vast accolades in the sporting arena belies the humble
                  beginnings he has come from, the bullying and ridicule he
                  endured as an overweight 12-year-old boy. Today Elton Davids’
                  name is proudly displayed on his many achievements 3 x IronMan
                  Finisher, Finisher of the ABSA Cape Epic, 23 x Cape Town Cycle
                  Tour finisher, Otter Trail runner, 200m Sprint Record holder,
                  Olympic Qualified Cycling Coach, Stock Car Racer, ran 7
                  Marathons across 7 Provinces in only 7 Days to name but a few.
                  What is more inspiring is that as a 12yr old, he had never
                  participated in any sporting activity, but was inspired by the
                  awards ceremony at his primary school. His desire to be part
                  of the team receiving the accolades and being named Sportsman
                  of the year propelled him to spend that entire December
                  vacation running and training. That was the start of the
                  sporting journey for this extraordinary athlete. <br />
                  35 years later, he remains committed to his community and uses
                  sport to raise awareness and funds to assist those communities
                  who are in need. Elton’s sporting acumen has elevated him as a
                  sports personality, athlete, leader, motivational speaker,
                  mentor, and coach. He is also a proud father to two beautiful
                  young ladies whom he loves spending time with. <br />
                  Although Elton continues to dedicate himself to community
                  projects, he has embarked on a business venture that taps into
                  his love for sport, his leadership skills, and his love for
                  his country. His years of experience, personal challenges,
                  vast networks, commitment to self and others will assist him
                  in attaining his next accolade, successful businessman. Let us
                  support him as he has supported so many others.
                </p>
              </div>
            </Col>
          </Row>
        </div>
      </Container>
    </div>
  );
};

export default Team;
